__turbopack_context__.v({
  "action": "RealPhoneSetup-module-scss-module__8HvqAG__action",
  "button": "RealPhoneSetup-module-scss-module__8HvqAG__button",
  "description": "RealPhoneSetup-module-scss-module__8HvqAG__description",
  "error": "RealPhoneSetup-module-scss-module__8HvqAG__error",
  "form": "RealPhoneSetup-module-scss-module__8HvqAG__form",
  "input-container": "RealPhoneSetup-module-scss-module__8HvqAG__input-container",
  "is-error": "RealPhoneSetup-module-scss-module__8HvqAG__is-error",
  "is-hidden": "RealPhoneSetup-module-scss-module__8HvqAG__is-hidden",
  "is-secondary": "RealPhoneSetup-module-scss-module__8HvqAG__is-secondary",
  "is-success": "RealPhoneSetup-module-scss-module__8HvqAG__is-success",
  "lead": "RealPhoneSetup-module-scss-module__8HvqAG__lead",
  "phone-input": "RealPhoneSetup-module-scss-module__8HvqAG__phone-input",
  "phone-input-country-code": "RealPhoneSetup-module-scss-module__8HvqAG__phone-input-country-code",
  "phone-number": "RealPhoneSetup-module-scss-module__8HvqAG__phone-number",
  "step": "RealPhoneSetup-module-scss-module__8HvqAG__step",
  "step-input-verificiation-code": "RealPhoneSetup-module-scss-module__8HvqAG__step-input-verificiation-code",
  "step-input-verificiation-code-lead-default": "RealPhoneSetup-module-scss-module__8HvqAG__step-input-verificiation-code-lead-default",
  "step-input-verificiation-code-lead-error": "RealPhoneSetup-module-scss-module__8HvqAG__step-input-verificiation-code-lead-error",
  "step-input-verificiation-code-lead-success": "RealPhoneSetup-module-scss-module__8HvqAG__step-input-verificiation-code-lead-success",
  "step-input-verificiation-code-success": "RealPhoneSetup-module-scss-module__8HvqAG__step-input-verificiation-code-success",
  "step-input-verificiation-code-timeout": "RealPhoneSetup-module-scss-module__8HvqAG__step-input-verificiation-code-timeout",
  "step-verify-input": "RealPhoneSetup-module-scss-module__8HvqAG__step-verify-input",
  "step-verify-sub-body": "RealPhoneSetup-module-scss-module__8HvqAG__step-verify-sub-body",
});
